import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, typography, spacing, rem } from './../../../styles';
import StyledFormOptionTextLabel from './form-option.label-text.styles';
var defaultStyles = function defaultStyles(_ref2) {
  var disabled = _ref2.disabled;
  return /*#__PURE__*/css("align-items:flex-start;color:", colors.coolGray_900, ";cursor:pointer;display:flex;height:auto;line-height:", typography.typographyLineHeightSm, ";max-width:100%;min-height:", rem(spacing.spacingControlHeightTouchOption), ";position:relative;&:active{user-select:none;}", disabled && /*#__PURE__*/css("cursor:default;opacity:1;&:hover,&:focus{opacity:1;}", StyledFormOptionTextLabel, "{color:", colors.coolGray_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ll9bqd",
  styles: "cursor:default"
} : {
  name: "ucx6ix-isReadOnlyStyles",
  styles: "cursor:default;label:isReadOnlyStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isReadOnlyStyles = function isReadOnlyStyles(_ref3) {
  var readOnly = _ref3.readOnly;
  if (readOnly) {
    return _ref;
  }
};
var resetStyles = getResetByTag('label');
var StyledFormOptionLabel = /*#__PURE__*/_styled('label', process.env.NODE_ENV === "production" ? {
  target: "eferxnl0"
} : {
  target: "eferxnl0",
  label: "StyledFormOptionLabel"
})(resetStyles, defaultStyles, isReadOnlyStyles);
export default StyledFormOptionLabel;